import { Button, Grid, Group } from '@mantine/core';
import React from 'react';
import { StepperPropsType } from '../../../type/button.types';

function StepperButton(props: StepperPropsType) {
  const { active, prevStep, nextStep, submit, loading, onClick } = props;
  return (
    <>
      <Grid mt={20}>
        <Grid.Col>
          <Group position='right'>
            {active !== 0 && (
              <Button
                onClick={prevStep}
                type='button'
                variant='outline'
                color='gray'
                sx={{ border: 'none' }}
                disabled={loading}
              >
                Back
              </Button>
            )}
            <Button
              type={submit ? 'submit' : 'button'}
              onClick={nextStep ? nextStep : onClick ? onClick : undefined}
              className='continue-btn'
              style={{ backgroundColor: '#4441d0', width: 150 }}
              loading={loading}
            >
              Continue
            </Button>
          </Group>
        </Grid.Col>
      </Grid>
    </>
  );
}

export default StepperButton;
